module.exports = __webpack_public_path__ + "media/notification-bell.ef832ab6.mp3";